import { ADD_FORM,
         SET_FORM_DATA,
         REMOVE_FORM,
         UPDATE_FORM,
         CLEAR_FORM_DATA,
         REMOVE_ALL_FORMS,
         REMOVE_FORM_FIELD } from 'src/vuex/mutation-type'
import formSchema from 'src/schema/form'
// import _ from 'lodash'

// initial state
const state = []

// mutations
const mutations = {
  [ADD_FORM] (state, form) {
    state.push(formSchema(form))
  },

  [SET_FORM_DATA] (state, data, index) {
    let form = state[index]
    _.forIn(data, (v, k) => { window.form[k] = v })
    form.data = Object.assign({}, form.data, _.omit(data, [false]))
  },

  [REMOVE_ALL_FORMS] (state) {
    state.splice(0, state.length)
  },

  [CLEAR_FORM_DATA] (state, data, index) {
    state[index].data = {}
  },

  [REMOVE_FORM] (state, index) {
    state.splice(index, 1)
  },

  [UPDATE_FORM] (state, form, index) {
    state.splice(index, 1, formSchema(form))
  },

  [REMOVE_FORM_FIELD] (state, keys, idx) {
    let form = state[idx]
    keys.forEach(k => { delete window.form[k] })
    form.data = Object.assign({}, _.omit(form.data, keys))
  }

}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/form.js